import firebase from 'firebase';
import React, { createContext, useContext } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { FirebaseUser } from '../types/types';
import { useCurrentUser } from './useCurrentUser';

export const UserDataContext = createContext<FirebaseUser | null>(null);

export const UserDataProvider: React.FC = ({ children }) => {
  const currentUser = useCurrentUser();
  const [data] = useDocumentData<FirebaseUser>(
    currentUser
      ? firebase.firestore().collection('users').doc(currentUser.uid)
      : undefined
  );
  return (
    <UserDataContext.Provider value={data || null}>
      {children}
    </UserDataContext.Provider>
  );
};

export const useCurrentUserData = () => useContext(UserDataContext);
